import request from "@/util/request.js";

// POST​/shiyizhihui_platform_api​/sys-promotion​/sysPromotionList
// 查询列表
export const sysPromotionList = (data) => {
  return request({
    url: "/sys-promotion/sysPromotionList",
    method: "post",
    data,
  });
};

// POST/shiyizhihui_platform_api​/sys-promotion​/saveOrUpdatePromotion
// 新增或者修改
export const saveOrUpdatePromotion = (data) => {
  return request({
    url: "/sys-promotion/saveOrUpdatePromotion",
    method: "post",
    data,
  });
};

// GET​/shiyizhihui_platform_api​/sys-promotion​/sysPromotionDeleteId
// 删除
export const sysPromotionDeleteId = (params) => {
  return request({
    url: "/sys-promotion/sysPromotionDeleteId",
    method: "get",
    params,
  });
};

// GET​/shiyizhihui_platform_api​/sys-promotion​/updateStatus
// 上架或者下架
export const updateStatus = (params) => {
  return request({
    url: "/sys-promotion/updateStatus",
    method: "get",
    params,
  });
};

export const fileDownLoad = (params) => {
  return request({
    url: "/common/backstage/file/fileDownLoad",
    method: "get",
    params,
    responseType: 'blob',
    isLoading: 1,
  });
};

// POST​/shiyizhihui_restaurant_api​/opinion​/getOpinion
// 意见反馈
export const getOpinion = (data) => {
  return request({
    url: "/opinion/getOpinion",
    method: "post",
    data,
  });
};